import React, { useEffect, useState } from "react";
import styles from "./style.module.scss";
import useDomainStore from "../../../stores/domain";

const StepperInput = ({
  label,
  onChange,
  min = 0,
  max = Infinity,
  value = 0,
  disabled = false,
  disableQuantityIncrease = false,
  disableQuantityDecrease = false,
}) => {
  const { isKurvDomain } = useDomainStore();
  const [counter, setCounter] = useState(value);

  useEffect(() => {
    setCounter(value);
  }, [value]);

  const onMinusClick = () => {
    if (counter > min) {
      const newValue = counter - 1;
      setCounter(newValue);
      onChange(newValue);
    }
  };

  const onPlusClick = () => {
    if (counter < max) {
      const newValue = counter + 1;
      setCounter(newValue);
      onChange(newValue);
    }
  };

  return (
    <div className={`${styles.formGroup} ${isKurvDomain ? styles.kurv_theme : ""}`}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles.inputContainer}>
        <span
          className={`${styles.minus} ${disabled || disableQuantityDecrease ? styles.disabled : ""}`}
          onClick={disableQuantityDecrease ? null : onMinusClick}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM10.5 8.5H5.5C5.36739 8.5 5.24022 8.44732 5.14645 8.35355C5.05268 8.25979 5 8.13261 5 8C5 7.86739 5.05268 7.74021 5.14645 7.64645C5.24022 7.55268 5.36739 7.5 5.5 7.5H10.5C10.6326 7.5 10.7598 7.55268 10.8536 7.64645C10.9473 7.74021 11 7.86739 11 8C11 8.13261 10.9473 8.25979 10.8536 8.35355C10.7598 8.44732 10.6326 8.5 10.5 8.5Z"
              fill="#A4A3A8"
            />
          </svg>
        </span>
        <span className={styles.counter}>{counter}</span>
        <span
          onClick={disableQuantityIncrease ? null : onPlusClick}
          className={`${styles.plus} ${disabled || disableQuantityIncrease ? styles.disabled : ""}`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
          >
            <path
              d="M8.16651 1.5C6.88093 1.5 5.62422 1.88122 4.5553 2.59545C3.48638 3.30968 2.65326 4.32484 2.16129 5.51256C1.66932 6.70028 1.5406 8.00721 1.7914 9.26809C2.04221 10.529 2.66127 11.6872 3.57031 12.5962C4.47935 13.5052 5.63754 14.1243 6.89842 14.3751C8.1593 14.6259 9.46623 14.4972 10.6539 14.0052C11.8417 13.5132 12.8568 12.6801 13.5711 11.6112C14.2853 10.5423 14.6665 9.28558 14.6665 8C14.6644 6.27675 13.9788 4.6247 12.7603 3.40618C11.5418 2.18766 9.88975 1.50215 8.16651 1.5ZM10.6665 8.5H8.66651V10.5C8.66651 10.6326 8.61383 10.7598 8.52006 10.8536C8.42629 10.9473 8.29912 11 8.16651 11C8.0339 11 7.90672 10.9473 7.81295 10.8536C7.71919 10.7598 7.66651 10.6326 7.66651 10.5V8.5H5.66651C5.5339 8.5 5.40672 8.44732 5.31295 8.35355C5.21919 8.25979 5.16651 8.13261 5.16651 8C5.16651 7.86739 5.21919 7.74021 5.31295 7.64645C5.40672 7.55268 5.5339 7.5 5.66651 7.5H7.66651V5.5C7.66651 5.36739 7.71919 5.24021 7.81295 5.14645C7.90672 5.05268 8.0339 5 8.16651 5C8.29912 5 8.42629 5.05268 8.52006 5.14645C8.61383 5.24021 8.66651 5.36739 8.66651 5.5V7.5H10.6665C10.7991 7.5 10.9263 7.55268 11.0201 7.64645C11.1138 7.74021 11.1665 7.86739 11.1665 8C11.1665 8.13261 11.1138 8.25979 11.0201 8.35355C10.9263 8.44732 10.7991 8.5 10.6665 8.5Z"
              fill="#A4A3A8"
            />
          </svg>
        </span>
      </div>
    </div>
  );
};

export default StepperInput;
